import { HiArrowRight } from "react-icons/hi2";
import "./Hero.scss";
import Button from "../../common/Button/Button";

const Hero = () => {
    const scrollToEmail = () => {
        const element = document.getElementById("email-capture");
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section id="home" className="hero">
            <div className="hero__container">
                <div className="hero__content">
                    <h1 className="hero__title">
                        <span className="title-line">
                            <span className="title-word title-word--1">
                                Nosotros
                            </span>
                            <span className="title-word title-word--2">
                                conectamos
                            </span>
                        </span>
                        <span className="title-line">
                            <span className="title-word title-word--3">
                                Ellos
                            </span>
                            <span className="title-word title-word--4">
                                capturan
                            </span>
                        </span>
                        <span className="title-line title-line--accent">
                            <span className="title-word title-word--accent">
                                Tú
                            </span>
                            <span className="title-word title-word--accent">
                                construyes
                            </span>
                        </span>
                    </h1>

                    <p className="hero__description">
                        Con{" "}
                        <span className="description-highlight">Atlyon</span>,
                        encontrar al socio ideal para tu proyecto de captura 3D
                        nunca fue tan sencillo.
                    </p>

                    <div className="hero__cta">
                        <Button
                            variant="filled"
                            onClick={scrollToEmail}
                            icon={<HiArrowRight />}
                        >
                            Empezar proyecto
                        </Button>
                        <Button
                            variant="outline"
                            onClick={() =>
                                document
                                    .getElementById("how-it-works")
                                    ?.scrollIntoView({ behavior: "smooth" })
                            }
                        >
                            Explorar
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
